/**
 * Get value of window field by JSON path dot notation
 *
 * @param {string} path json path dot notation to desired value on window
 * @param {*} [default_value] default value, optional
 *
 * @returns {* | undefined} Field value, or default value, or undefined
 *
 * @example isset('config.tv.aspect_ratio') // returns 6
 * @example isset('config['tv'].aspect_ratio') // returns 6
 * @example isset('config["tv"].aspect_ratio') // returns 6
 * @example isset('nonexistent.object.and.value') // returns undefined
 * @example isset('nonexistent.object.and.value', ['asd']) // returns ['asd']
 */
export function isset<T extends any>(path: string, default_value?: T): T | undefined {
  let result = path
    .replace(/\"/gi, "'")
    .replace(/\'\]/gi, '')
    .split(/\.|\[\'/i)
    .reduce((acc, prop) => acc?.[prop], window as any);

  return result == null ? default_value : result;
}

window.isset = isset;
